import * as React from "react";
const SvgVisa = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 125.43 78.39" {...props}>
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <rect
          width={125.43}
          height={78.39}
          fill="#3957a7"
          rx={4.18}
          ry={4.18}
        />
        <path
          fill="#fff"
          d="M57.72 50.97h-6.13l3.83-23.53h6.13zM46.44 27.44 40.6 43.62l-.69-3.48-2.06-10.58a2.63 2.63 0 0 0-2.91-2.12h-9.66l-.11.4a22.8 22.8 0 0 1 6.41 2.69L36.9 51h6.39L53 27.44zM94.63 51h5.63l-4.9-23.53h-4.93a2.81 2.81 0 0 0-2.83 1.75L78.46 51h6.39l1.27-3.49h7.8zm-6.74-8.32 3.22-8.81 1.81 8.81zm-8.95-9.58.87-5.1a17.7 17.7 0 0 0-5.51-1C71.26 27 64 28.35 64 34.81c0 6.08 8.48 6.15 8.48 9.35s-7.6 2.62-10.11.6l-.91 5.29a17.1 17.1 0 0 0 6.91 1.33c4.18 0 10.49-2.17 10.49-8.06 0-6.12-8.55-6.69-8.55-9.35s6.01-2.32 8.63-.87"
        />
        <path
          fill="#f9a533"
          d="m39.91 40.14-2.06-10.58a2.63 2.63 0 0 0-2.91-2.12h-9.66l-.11.4a23.7 23.7 0 0 1 9.09 4.56 18.4 18.4 0 0 1 5.65 7.74"
        />
      </g>
    </g>
  </svg>
);
export default SvgVisa;
